import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiBreadcrumbSectionDTO,
  BreadcrumbSectionDTO,
} from "@lib/strapi/dtos/components/sections/breadcrumbSection.dto";
import {
  StrapiSEODTO,
  SEODTO,
} from "@lib/strapi/dtos/components/shared/sEO.dto";

export class StrapiWebPageDTO {
  constructor() {}

  title: string;
  slug: string;
  headingZone: StrapiDynamicZoneComponentDTO[];
  breadcrumb: StrapiBreadcrumbSectionDTO;
  contentSections: StrapiDynamicZoneComponentDTO[];
  asideSections: StrapiDynamicZoneComponentDTO[];
  bottomSections: StrapiDynamicZoneComponentDTO[];
  contentWidth: "Standard" | "Wide" | "Narrow";
  seo: StrapiSEODTO;
}

export class WebPageDTO {
  constructor() {}

  extraData: any = {};
  title: string;
  slug: string;
  headingZone: DynamicZoneComponentDTO[];
  breadcrumb: BreadcrumbSectionDTO;
  contentSections: DynamicZoneComponentDTO[];
  asideSections: DynamicZoneComponentDTO[];
  bottomSections: DynamicZoneComponentDTO[];
  contentWidth: "Standard" | "Wide" | "Narrow";
  seo: SEODTO;
}
